import { render, staticRenderFns } from "./WhatsAppContactButton.vue?vue&type=template&id=795d149b&"
import script from "./WhatsAppContactButton.vue?vue&type=script&lang=js&"
export * from "./WhatsAppContactButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
